import { action } from "@ember/object";
import { service } from "@ember/service";
import GroupRequestsController from "discourse/controllers/group/requests";
import { ajax } from "discourse/lib/ajax";
import { popupAjaxError } from "discourse/lib/ajax-error";
import DiscourseURL from "discourse/lib/url";
import CirclesMembershipReasonModal from "../../components/modal/membership-reason";
import Circle from "../../models/circle";

export default class CircleRequestsController extends GroupRequestsController {
  @service siteSettings;
  @service modal;

  @action
  loadMore() {
    this.findRequesters();
  }

  @action
  async acceptRequest(user) {
    await this.handleRequest({ user_id: user.get("id"), accept: true });

    const userCount = this.model.user_count;
    this.model.set("user_count", userCount + 1);

    user.setProperties({
      request_accepted: true,
      request_denied: false,
    });
  }

  @action
  async undoAcceptRequest(user) {
    await ajax("/groups/" + this.get("model.id") + "/members.json", {
      type: "DELETE",
      data: { user_id: user.get("id") },
    });

    const userCount = this.model.user_count;
    this.model.set("user_count", userCount - 1);

    user.set("request_undone", true);
  }

  @action
  async denyRequest(user) {
    const performDeny = async (reason) => {
      const response = await this.handleRequest({
        user_id: user.get("id"),
        accept: false,
        reason,
      });

      if (response) {
        user.setProperties({
          request_accepted: false,
          request_denied: true,
        });

        // redirects the page if the response contains a relative URL to a
        // message
        if (
          this.siteSettings.discourse_circles_redirect_to_message_after_deny &&
          response.relative_url
        ) {
          DiscourseURL.routeTo(response.relative_url);
        }
      }
    };

    if (this.siteSettings.discourse_circles_ask_reason_when_denying_request) {
      this.modal.show(CirclesMembershipReasonModal, {
        model: {
          circle: this.circleModel,
          // because controllers are singletons. ensures that the reason will
          // be empty
          reason: "",
          mode: "deny",
          onSubmit: performDeny,
        },
      });
    } else {
      return await performDeny();
    }
  }

  async handleRequest(data) {
    try {
      const response = await Circle.handleMembershipRequest(
        this.circleModel.category_id,
        data
      );

      if (this.model.request_count > 0) {
        this.model.set("request_count", this.model.request_count - 1);
      }

      return response;
    } catch (e) {
      popupAjaxError(e);
    }
  }
}
